export const DOWNLOAD_ASSETS = 'DOWNLOAD_ASSETS';
export const FETCH_CONTRACTS = 'FETCH_CONTRACTS';
